"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positiveMod = void 0;
var _0n = BigInt(0);
function positiveMod(x, n) {
    n = typeof n === "bigint" ? n : BigInt(n);
    x = typeof x === "bigint" ? x : BigInt(x);
    var res = x % n;
    return res < _0n ? res + n : res;
}
exports.positiveMod = positiveMod;
